import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-105342b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "a-formField" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["data-qa"]
const _hoisted_4 = ["id", "name", "value", "data-qa"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.label && _ctx.placeholderState)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              class: "a-formField__placeholder",
              for: _ctx.name
            }, _toDisplayString(_ctx.label), 9, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.hasSubmitAction)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "a-formField__action",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
          "data-qa": _ctx.actionQaSelector
        }, [
          _createVNode(_component_IconComponent, {
            "icon-id": _ctx.iconName.ArrowFull
          }, null, 8, ["icon-id"])
        ], 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      class: "a-formInput",
      type: "text",
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args))),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.placeholderState = false)),
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.placeholderState = _ctx.value === '')),
      onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"])),
      id: _ctx.name,
      name: _ctx.name,
      value: _ctx.value,
      "data-qa": _ctx.inputQaSelector
    }, null, 40, _hoisted_4)
  ]))
}